import { useRef, type KeyboardEvent } from "react";

import type { PublicWhoPlays } from "../../lib/api";

const OPTIONS: Array<{ value: PublicWhoPlays; title: string; hint: string; icon: string }> = [
  { value: "child", title: "Mi hijo o hija", hint: "o a otra persona", icon: "👧" },
  { value: "self", title: "Yo", hint: "me inscribo a mí", icon: "🎾" },
];

/** «¿Quién va a jugar?» (Eduardo 2026-10-01): dos opciones grandes. Es un
 * grupo de radio accesible: las flechas mueven y eligen, Tab entra y sale. */
export default function WhoPlaysChoice({
  value,
  onChange,
}: {
  value: PublicWhoPlays;
  onChange: (value: PublicWhoPlays) => void;
}) {
  const buttons = useRef<Array<HTMLButtonElement | null>>([]);

  function move(event: KeyboardEvent<HTMLButtonElement>, index: number) {
    const forward = event.key === "ArrowRight" || event.key === "ArrowDown";
    const backward = event.key === "ArrowLeft" || event.key === "ArrowUp";
    if (!forward && !backward) return;
    event.preventDefault();
    const next = (index + (forward ? 1 : -1) + OPTIONS.length) % OPTIONS.length;
    onChange(OPTIONS[next].value);
    buttons.current[next]?.focus();
  }

  return (
    <section className="public-registration-who-plays" aria-labelledby="public-registration-who-plays-title">
      <h3 id="public-registration-who-plays-title" className="public-registration-who-plays__title">¿Quién va a jugar?</h3>
      <div className="public-registration-who-plays__options" role="radiogroup" aria-labelledby="public-registration-who-plays-title">
        {OPTIONS.map((option, index) => {
          const checked = option.value === value;
          return (
            <button
              key={option.value}
              ref={(element) => { buttons.current[index] = element; }}
              type="button"
              role="radio"
              aria-checked={checked}
              tabIndex={checked ? 0 : -1}
              className={`public-registration-who-plays__option${checked ? " is-selected" : ""}`}
              onClick={() => onChange(option.value)}
              onKeyDown={(event) => move(event, index)}
            >
              <span className="public-registration-who-plays__icon" aria-hidden="true">{option.icon}</span>
              <span className="public-registration-who-plays__text">
                <strong>{option.title}</strong>
                <small>{option.hint}</small>
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
